import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, deleteStatus } from 'store/data/statuses';

export function useDeleteStatus(): Operation<(statusName: string) => Promise<void>> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.DELETE_STATUS);

	async function handler(statusName: string) {
		if (loading) return;
		if (error) resetError();

		await dispatch(deleteStatus(statusName));
	}

	return [{ loading, error }, handler];
}
